import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Left from '@material-ui/icons/ChevronLeftRounded';
import { IArrowProps } from '../../EventToday/ArrowRight';

export const LeftArrow = ({ onClick }: IArrowProps) => (
  <IconButton className="arrow" onClick={onClick}>
    <Left color="primary" fontSize="large" />
  </IconButton>
);
